import dayjs from 'dayjs';
import { DatePicker, Space } from '@timeedit/ui-components/antd';

export const DateRangePicker = ({
  value,
  onChange,
  timezone,
}: DateRangePickerProps) => {
  return (
    <Space>
      <DatePicker
        size="small"
        value={
          value.dateStart ? dayjs(value.dateStart).tz(timezone) : undefined
        }
        onChange={(_, dateString: string) => {
          onChange({
            dateStart: dateString
              ? dayjs.tz(dateString, timezone).toDate()
              : null,
            dateEnd: value.dateEnd,
          });
        }}
      />
      <label>-</label>
      <DatePicker
        size="small"
        value={value.dateEnd ? dayjs(value.dateEnd).tz(timezone) : undefined}
        onChange={(_, dateString: string) => {
          onChange({
            dateStart: value.dateStart,
            dateEnd: dateString
              ? dayjs.tz(dateString, timezone).toDate()
              : null,
          });
        }}
      />
    </Space>
  );
};

type DateRangePickerProps = {
  value: DateRange;
  onChange: (DateRange: DateRange) => void;
  timezone: string;
};

type DateRange = {
  dateStart: Date | null | undefined;
  dateEnd: Date | null | undefined;
};
